import { useState, useRef } from 'react';
import './grid.scss';
import { DataGridPro, GridApi, GridRowData, GridSelectionModel } from '@mui/x-data-grid-pro';
import { ManageNotData } from '../manageNotData/ManageNotData';

export function LocalGrid(props: any) {
  const apiRef: any = useRef<GridApi>();
  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);

  const handleOnSelectionModelChange = (model: GridSelectionModel) => {
    setSelectionModel(model);
  };

  const AddedActions = props.addedActions;

  const getRowId = (row: GridRowData) => {
    if (row.whois) {
      return row[props.identifier] + row.type;
    }
    return row[props.identifier];
  };

  return (
    <div className="grid">
      {props.addedActions ? (
        <div className="utilities-row">
          <AddedActions ids={selectionModel} />
        </div>
      ) : (
        ''
      )}
      <div className="grid-scope">
        <div style={{ height: '100%', width: '100%', background: '#FFFFFF', position: 'relative' }}>
          <DataGridPro
            components={{
              NoRowsOverlay: () => <ManageNotData />
            }}
            apiRef={apiRef}
            rows={props.rows}
            columns={props.columns}
            onSelectionModelChange={handleOnSelectionModelChange}
            selectionModel={selectionModel}
            filterMode="server"
            sortingMode="server"
            disableMultipleColumnsSorting={true}
            disableSelectionOnClick={true}
            disableColumnReorder={true}
            checkboxSelection
            disableColumnMenu={true}
            hideFooter={true}
            getRowId={row => getRowId(row)}
          />
        </div>
      </div>
    </div>
  );
}
